<template lang="html">
  <v-container class='fluid'>

    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Criar Atividade'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Nome e descrição sucinta da atividade -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-textarea
                      label='Nome e descrição sucinta da atividade'
                      v-model="atividade.descricao"
                      rows="1"
                      auto-grow
                      :rules="nomeDescricaoAtividadeRules"
                      counter="250">
                    </v-textarea>
                  </v-flex>
                </v-layout>

                <!-- Principal objetivo específico ao qual esta atividade está vinculada -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-select
                      label='Principal objetivo específico ao qual esta atividade está vinculada'
                      :items="objetivosEspecificosTopicos"
                      v-model="atividade.objetivoEspecifico"
                      item-text="nome"
                      item-value="nome"
                      prepend-icon="dashboard"
                      :rules="obrigatorio"
                      autocomplete
                    >
                      <template slot="no-data">
                        Não existem objetivos específicos cadastrados.
                      </template>
                    </v-select>
                  </v-flex>
                </v-layout>

                <!-- Situação da atividade -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-select
                      label='Situação da atividade'
                      :items="listaSituacaoAtividade"
                      v-model="atividade.situacaoAtividade"
                      item-text="descricao"
                      item-value="item"
                      prepend-icon="dashboard"
                      :rules="obrigatorio"
                      autocomplete
                      return-object
                      @change="limpaDatasResultados()"
                    ></v-select>
                  </v-flex>
                </v-layout>

                <!-- Apenas na situação "Não iniciada" -->
                <v-layout row wrap v-if="atividade.situacaoAtividade.item === 1">

                  <!-- Data de início prevista -->
                  <v-flex xs11 sm5>
                    <c-date-menu
                      label="Data de início prevista"
                      v-model="atividade.dtInicioPrevisto"
                      :rules="atividade.situacaoAtividade.item === 1 ? obrigatorio : null"
                      >
                    </c-date-menu>
                  </v-flex>

                  <v-spacer></v-spacer>

                  <!-- Data de conclusão prevista -->
                  <v-flex xs11 sm5>
                    <c-date-menu
                      label="Data de conclusão prevista"
                      v-model="atividade.dtFimPrevisto"
                      :rules="atividade.situacaoAtividade.item === 1 ? obrigatorio : null"
                      >
                    </c-date-menu>
                  </v-flex>

                </v-layout>

                <!-- Apenas na situação "Em andamento" -->
                <v-layout row wrap v-if="atividade.situacaoAtividade.item === 2">

                  <!-- Data de início efetiva -->
                  <v-flex xs11 sm5>
                    <c-date-menu
                      label="Data de início efetiva"
                      v-model="atividade.dtInicioEfetivo"
                      :rules="atividade.situacaoAtividade.item === 2 ? obrigatorio : null"                      
                      >
                    </c-date-menu>
                  </v-flex>

                  <v-spacer></v-spacer>

                  <!-- Data de conclusão prevista -->
                  <v-flex xs11 sm5>
                    <c-date-menu
                      label="Data de conclusão prevista"
                      v-model="atividade.dtFimPrevisto"
                      :rules="atividade.situacaoAtividade.item === 2 ? obrigatorio : null"  
                      >
                    </c-date-menu>
                  </v-flex>

                </v-layout>

                <!-- Apenas na situação "Cumprida" -->
                <v-layout row wrap v-if="atividade.situacaoAtividade.item === 3">

                  <!-- Data de início efetiva -->
                  <v-flex xs11 sm5>
                    <c-date-menu
                      label="Data de início efetiva"
                      v-model="atividade.dtInicioEfetivo"
                      :rules="atividade.situacaoAtividade.item === 3 ? obrigatorio : null"                      
                      >
                    </c-date-menu>
                  </v-flex>

                  <v-spacer></v-spacer>

                  <!-- Data de conclusão efetiva -->
                  <v-flex xs11 sm5>
                    <c-date-menu
                      label="Data de conclusão efetiva"
                      v-model="atividade.dtFimEfetivo"
                      :rules="atividade.situacaoAtividade.item === 3 ? obrigatorio : null"
                      >
                    </c-date-menu>
                  </v-flex>

                </v-layout>
           
                <!-- Resultados -->
                <v-layout row wrap justify-space-between v-if="atividade.situacaoAtividade.item === 2 || atividade.situacaoAtividade.item === 3">
                  <v-flex xs12>
                    <v-textarea
                      label='Resultados'
                      v-model="atividade.resultados"
                      rows="3"
                      auto-grow
                      :rules="resultadosRules"
                      counter="1000">
                    </v-textarea>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
            <v-divider></v-divider>

            <v-card-actions>

              <!-- Cancelar -->
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Criar -->
              <v-btn color="primary" text @click="criarAtividade(false)" :disabled="!formularioValido">Criar</v-btn>

              <!-- Criar e Avançar -->
              <v-btn color="primary" text @click="criarAtividade(true)" :disabled="!formularioValido">Criar e Avançar</v-btn>

            </v-card-actions>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      atividade: {
        descricao: '',
        detalhamento: '',
        situacaoAtividade: {item: 1, descricao: 'Não iniciada'},
        dtInicioPrevisto: '',
        dtInicioEfetivo: '',
        dtFimPrevisto: '',
        dtFimEfetivo: ''
      },
      projeto: {
        titulo: '',
        dataInicio: '',
        dataConclusao: '',
        observacoes: '',
        situacao: {},
        tipoPublico: {},
        tipoEvento: {}
      },
      objetivosEspecificosTopicos: [],
      listaSituacaoAtividade: [
        {item: 1, descricao: 'Não iniciada'},
        {item: 2, descricao: 'Em andamento'},
        {item: 3, descricao: 'Cumprida'}
      ],
      obrigatorio: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      nomeDescricaoAtividadeRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 250 || 'Este campo não pode possuir mais que 250 caracteres'
      ],
      resultadosRules: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      limpaDatasResultados: function () {
        this.atividade.dtInicioPrevisto = null
        this.atividade.dtFimPrevisto = null
        this.atividade.dtInicioEfetivo = null
        this.atividade.dtFimEfetivo = null
        this.atividade.resultados = null
      },
      cancelar: function () {
        this.$router.push({name: 'AtividadesProjeto', params: {idProjeto: this.idProjeto}})
      },
      criarAtividade: function (avancar) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando nova atividade.' })
        // Atividade "Em andamento"
        if (this.atividade.situacaoAtividade.item === 2) {
          this.atividade.dtInicioPrevisto = this.atividade.dtInicioEfetivo
        }
         // Atividade "Cumprida"
        if (this.atividade.situacaoAtividade.item === 3) {
          this.atividade.dtInicioPrevisto = this.atividade.dtInicioEfetivo
          this.atividade.dtFimPrevisto = this.atividade.dtFimEfetivo
        }
        projetos.postAtividadesDoProjeto(this.idProjeto, this.atividade)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          if (avancar === false) {
            this.atividade.descricao = ''
            this.$router.push({name: 'AtividadesProjeto', params: {idProjeto: this.idProjeto}})
          } else {
            this.$router.push({name: 'NovaParceria', params: {idProjeto: this.idProjeto}})
          }
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando nova atividade.' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.dataInicioFormatada = this.dates.format(this.projeto.dataInicio)
        this.dataConclusaoFormatada = this.dates.format(this.projeto.dataConclusao)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
      projetos.getExtensaoDoProjeto(this.idProjeto)
      .then(response => {
        this.extensao = response.data
        let aux = this.extensao.objetivosEspecificos.split(';;')
        for (let item in aux) {
          this.objetivosEspecificosTopicos.push({id: item, nome: aux[item]})
        }
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// nova-atividade.vue?181dd907